export const RUNSHEET_SCROLLABLE_CELL_MAX = 120;

export const getBookingPaymentTotal = (booking: any): number => {
  let total = 0;

  if (!booking?.deposits) return total;

  booking.deposits.forEach((deposit: any) => {
    if (!deposit.type || deposit.status === "paid") {
      if (deposit.type && deposit.type.indexOf("_auth") > 0) {
        deposit.claims?.forEach((claim: any) => {
          const amount =
            typeof claim.amount === "object"
              ? parseFloat(claim.amount.amount)
              : parseFloat(claim.amount);
          total += amount;
        });
      } else {
        const amount =
          typeof deposit.amount === "object"
            ? parseFloat(deposit.amount.amount)
            : parseFloat(deposit.amount);
        total += amount;
      }

      const refunds = deposit.refunds || deposit.refund_ids || [];
      refunds.forEach((refundRef: any) => {
        const refund = booking.refunds?.find(
          (r: any) => r.id === refundRef || r.refund_ref === refundRef
        );
        if (refund) {
          const refundAmount =
            typeof refund.amount === "object"
              ? parseFloat(refund.amount.amount)
              : parseFloat(refund.amount);
          total -= refundAmount;
        }
      });
    }
  });
  const finalTotal = total / 100;

  return parseFloat(finalTotal.toFixed(2));
};

export const getBookingAuthTotal = (booking: any): number => {
  let total = 0;

  if (!booking?.deposits) return total;

  booking.deposits.forEach((deposit: any) => {
    if (
      ["manual_auth", "request_auth"].includes(deposit.type) &&
      deposit.status === "paid"
    ) {
      const amount =
        typeof deposit.amount === "object"
          ? parseFloat(deposit.amount.amount)
          : parseFloat(deposit.amount);
      total += amount;
    }
  });
  const finalTotal = total / 100;
  return parseFloat(finalTotal.toFixed(2));
};

export const getActivePreorderCount = (booking: any): number => {
  let counter = 0;

  if (booking?.preorders) {
    booking.preorders.forEach((preorder: any) => {
      if (!preorder.status || preorder.status !== "deleted") {
        counter += 1;
      }
    });
  }

  return counter;
};

export const lightenColor = (hexColor: string, percentage: number): string => {
  const hex = hexColor.replace("#", "");

  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);

  const factor = percentage / 100;
  const newR = Math.min(255, Math.round(r + (255 - r) * factor));
  const newG = Math.min(255, Math.round(g + (255 - g) * factor));
  const newB = Math.min(255, Math.round(b + (255 - b) * factor));

  const toHex = (n: number) => n.toString(16).padStart(2, "0");
  return toHex(newR) + toHex(newG) + toHex(newB);
};

export const getForegroundColor = (hexColor: string): string => {
  const hex = hexColor.replace("#", "");

  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);

  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  return luminance > 0.5 ? "#3c3c3c" : "#ffffff";
};

/**
 * Calculates the height for booking cards in the runsheet
 *
 * For runsheet cards, returns a fixed height of 160px to ensure consistent UI.
 * For regular diary cards, returns the standard height.
 *
 * @param booking - The booking object containing all booking data
 * @param isOnRunSheet - Whether this card is being rendered in runsheet view
 * @returns The height in pixels for the booking card
 */
export const calculateDynamicHeight = (
  booking: any,
  isOnRunSheet?: boolean
): number => {
  if (!booking || booking.isDivider) return 36;

  if (!isOnRunSheet) {
    return 89;
  }

  return 160;
};

export const getBookingCardStyles = (booking: any, venueConfig: any) => {
  const styles: { [key: string]: any } = {};

  if (!booking.current_stage || booking.current_stage === "left") {
    return styles;
  }

  const stageDetails = venueConfig?.booking_stages?.find(
    (stage: any) => stage.id === booking.current_stage
  );

  if (stageDetails?.colour) {
    const backgroundColour = lightenColor(stageDetails.colour, 20);

    styles.backgroundColor = `#${backgroundColour}`;
    styles.color = getForegroundColor(backgroundColour);
  }

  return styles;
};
